import { render, staticRenderFns } from "./print_waiFa.vue?vue&type=template&id=6ed25d5b&scoped=true&"
import script from "./print_waiFa.vue?vue&type=script&lang=js&"
export * from "./print_waiFa.vue?vue&type=script&lang=js&"
import style0 from "./print_waiFa.vue?vue&type=style&index=0&id=6ed25d5b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed25d5b",
  null
  
)

export default component.exports